// removed by extract-text-webpack-plugin
module.exports = {"copywrite":"src-components-footer-copy-write----copy-write-module---copywrite---2r11L"};


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/copy-write/copy-write.module.css
// module id = 163
// module chunks = 35783957827783 114276838955818